import banner from "../../../courses/presupuesto-ahorro.webp";

const modulo9 = {
  courseId: "cripto-blockchain",
  id: "modulo-9",
  title: "🧪 MODULE 9: Final Evaluation",
  estimatedDuration: "30–45 minutes",
  format: "Online final exam + optional reflection",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objectives",
      title: "🎯 Module objectives",
      content: [
        {
          type: "list",
          items: [
            "Verify that you understand the key concepts of the crypto ecosystem.",
            "Validate your readiness to interact with the Web3 world safely and consciously.",
            "Obtain your ZyVerse Professional Certificate in Crypto and Blockchain.",
          ],
        },
      ],
    },
    {
      id: "info",
      navLabel: "What does this evaluation include?",
      title: "📝 What does this evaluation include?",
      content: [
        {
          type: "paragraph",
          text: "📌 Final exam",
        },
        {
          type: "list",
          items: [
            "20 multiple-choice questions",
            "Based on modules 1 to 8",
            "Topics: blockchain, cryptocurrencies, stablecoins, wallets, security, Web3, DeFi, NFTs",
            "Estimated duration: 25–30 minutes",
            "Minimum passing score: 60% correct answers",
          ],
        },
      ],
    },
    {
      id: "luego-examen",
      navLabel: "What happens after the exam?",
      title: "📤 What happens after the exam?",
      content: [
        {
          type: "list",
          items: [
            "If you get 10 correct answers or more, you will be able to access the certificate payment ($200 MXN).",
            "The certificate will be issued in PDF format within 3 to 5 business days.",
            "You can use it to validate complementary hours, strengthen your CV, or share it on LinkedIn.",
          ],
        },
      ],
    },
    {
      id: "examen-final",
      navLabel: "Final Exam",
      title: "📝 Final exam (without marked answers)",
      questions: [
        {
          id: "q1",
          question: "What is the main purpose of a blockchain?",
          options: [
            { key: "a", text: "Store photos and videos" },
            { key: "b", text: "Validate personal data" },
            {
              key: "c",
              text: "Record transactions securely and in a decentralized way",
            },
            { key: "d", text: "Generate money automatically" },
          ],
          correct: "c",
        },
        {
          id: "q2",
          question: "What makes blockchain technology unique?",
          options: [
            { key: "a", text: "Its speed" },
            { key: "b", text: "The use of traditional banks" },
            {
              key: "c",
              text: "Its transparency and resistance to manipulation",
            },
            { key: "d", text: "It only works with Bitcoin" },
          ],
          correct: "c",
        },
        {
          id: "q3",
          question: "Which cryptocurrency is known as “digital gold”?",
          options: [
            { key: "a", text: "Ethereum" },
            { key: "b", text: "Bitcoin" },
            { key: "c", text: "Solana" },
            { key: "d", text: "USDT" },
          ],
          correct: "b",
        },
        {
          id: "q4",
          question:
            "Which network is known for smart contracts and decentralized applications?",
          options: [
            { key: "a", text: "Polygon" },
            { key: "b", text: "Ethereum" },
            { key: "c", text: "Stellar" },
            { key: "d", text: "Binance" },
          ],
          correct: "b",
        },
        {
          id: "q5",
          question: "What characterizes stablecoins?",
          options: [
            { key: "a", text: "Their extreme volatility" },
            { key: "b", text: "They are only used in games" },
            {
              key: "c",
              text: "They maintain a stable value, such as 1 dollar",
            },
            { key: "d", text: "They work without backing" },
          ],
          correct: "c",
        },
        {
          id: "q6",
          question: "What is the function of a wallet?",
          options: [
            { key: "a", text: "Store and manage your crypto assets" },
            {
              key: "b",
              text: "Automatically convert crypto into physical money",
            },
            { key: "c", text: "Buy products directly" },
            { key: "d", text: "Replace your bank" },
          ],
          correct: "a",
        },
        {
          id: "q7",
          question: "What is a seed phrase?",
          options: [
            { key: "a", text: "A credit card" },
            { key: "b", text: "A QR code" },
            {
              key: "c",
              text: "A set of words that allows you to recover your wallet",
            },
            { key: "d", text: "Your username on the blockchain" },
          ],
          correct: "c",
        },
        {
          id: "q8",
          question: "Which type of wallet gives the user more control?",
          options: [
            { key: "a", text: "Custodial" },
            { key: "b", text: "Non-custodial" },
            { key: "c", text: "Digital" },
            { key: "d", text: "Bank wallet" },
          ],
          correct: "b",
        },
        {
          id: "q9",
          question: "What can happen if you share your seed phrase?",
          options: [
            { key: "a", text: "You will receive more crypto" },
            { key: "b", text: "Nothing happens" },
            { key: "c", text: "Someone can steal all your funds" },
            { key: "d", text: "You only lose access for a few hours" },
          ],
          correct: "c",
        },
        {
          id: "q10",
          question: "Which is an example of a network with very low fees?",
          options: [
            { key: "a", text: "Ethereum" },
            { key: "b", text: "Stellar" },
            { key: "c", text: "Bitcoin" },
            { key: "d", text: "Binance Smart Chain" },
          ],
          correct: "b",
        },
        {
          id: "q11",
          question: "What is DeFi?",
          options: [
            { key: "a", text: "A technology company" },
            { key: "b", text: "A new cryptocurrency" },
            {
              key: "c",
              text: "A financial system without banks or intermediaries",
            },
            { key: "d", text: "A blockchain-based game" },
          ],
          correct: "c",
        },
        {
          id: "q12",
          question: "What is a blockchain explorer used for?",
          options: [
            { key: "a", text: "To play with NFTs" },
            { key: "b", text: "To review public transactions on the network" },
            { key: "c", text: "To mine cryptocurrencies" },
            { key: "d", text: "To change your private key" },
          ],
          correct: "b",
        },
        {
          id: "q13",
          question:
            "What is the main difference between a token and a cryptocurrency?",
          options: [
            { key: "a", text: "A token lives inside an existing network" },
            { key: "b", text: "A cryptocurrency is more secure" },
            { key: "c", text: "A token is only used in games" },
            { key: "d", text: "They are exactly the same" },
          ],
          correct: "a",
        },
        {
          id: "q14",
          question: "What is an NFT?",
          options: [
            {
              key: "a",
              text: "A unique digital asset with verified ownership",
            },
            { key: "b", text: "A stablecoin" },
            { key: "c", text: "An employment contract" },
            { key: "d", text: "A file with no value" },
          ],
          correct: "a",
        },
        {
          id: "q15",
          question: "What should you check before sending cryptocurrencies?",
          options: [
            { key: "a", text: "The receiver’s name" },
            { key: "b", text: "The correct network and token compatibility" },
            { key: "c", text: "The icon color" },
            { key: "d", text: "That it is nighttime" },
          ],
          correct: "b",
        },
        {
          id: "q16",
          question: "What is phishing in the crypto world?",
          options: [
            { key: "a", text: "A new type of token" },
            { key: "b", text: "A sending error" },
            {
              key: "c",
              text: "A scam attempt using fake links or misleading emails",
            },
            { key: "d", text: "The process of buying tokens" },
          ],
          correct: "c",
        },
        {
          id: "q17",
          question: "What is an airdrop?",
          options: [
            {
              key: "a",
              text: "A crypto reward you receive for free",
            },
            { key: "b", text: "A new wallet" },
            { key: "c", text: "A network error" },
            { key: "d", text: "A type of scam" },
          ],
          correct: "a",
        },
        {
          id: "q18",
          question: "What does a platform like Stellar Quest offer?",
          options: [
            { key: "a", text: "Buying cars online" },
            { key: "b", text: "Learning through challenges while earning XLM" },
            { key: "c", text: "Directly exchanging dollars for crypto" },
            { key: "d", text: "Opening a bank account" },
          ],
          correct: "b",
        },
        {
          id: "q19",
          question:
            "What is the difference between Vesseo and a traditional bank?",
          options: [
            { key: "a", text: "Vesseo does not store your money in cash" },
            {
              key: "b",
              text: "Vesseo does not control your funds: you have custody",
            },
            { key: "c", text: "Vesseo charges interest" },
            { key: "d", text: "There is no difference" },
          ],
          correct: "b",
        },
        {
          id: "q20",
          question: "What is the philosophy of the course?",
          options: [
            { key: "a", text: "Make money fast" },
            {
              key: "b",
              text: "Understand before investing and act safely",
            },
            { key: "c", text: "Buy crypto and forget everything else" },
            { key: "d", text: "Every investment makes a profit" },
          ],
          correct: "b",
        },
      ],
    },
    {
      id: "finalizacion",
      navLabel: "Congratulations for making it this far!",
      title: "🎖️ Congratulations for making it this far!",
      content: [
        "“Investing in your financial and digital education is one of the best decisions you can make.”",
      ],
    },
    {
      id: "reflexion-final",
      navLabel: "Final reflection",
      title: "💭 Final reflection (optional, but recommended)",
      content: [
        {
          type: "paragraph",
          text: "Suggested topic:",
        },
        {
          type: "paragraph",
          text: "“What did I learn and how will I apply it?”",
        },
        {
          type: "paragraph",
          text: "You can write a short text, around 1 to 2 pages, or record a short audio or video where you share:",
        },
        {
          type: "list",
          items: [
            "Which modules impacted you the most?",
            "What habits have you changed or do you plan to change?",
            "What did you learn about yourself and your relationship with digital money?",
            "How will you use this knowledge in your personal or professional life?",
          ],
        },
      ],
    },
  ],
};

export default modulo9;
